var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"loader_container",class:_vm.fullScreen ? 'full-vh' : 'full-percent',attrs:{"fluid":"","pa-0":""}},[_c('div',{staticClass:"loader_content"},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":"primary","indeterminate":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }